export const home = {
  pageTitle: "BajApp Xperiences — Tours, Transporte y Experiencias en Baja California Sur",
  nav: {
    tours: "Tours",
    transportes: "Transportes",
    hospedaje: "Hospedaje",
    experiencias: "Experiencias",
    eventos: "Eventos",
    paraProveedores: "Para Proveedores",
    login: "Iniciar sesión",
    register: "Registrarse",
    myAccount: "Mi cuenta",
    bookings: "Mis reservas",
    providerPanel: "Panel de proveedor",
    adminPanel: "Administración",
    logout: "Cerrar sesión",
  },
  hero: {
    title: "Descubre Baja California Sur",
    subtitle: "Tours, transporte y experiencias auténticas con proveedores locales",
    searchPlaceholder: "¿A dónde quieres ir?",
    categoryLabel: "Categoría",
    dateLabel: "Fecha",
    peopleLabel: "Personas",
    adultsLabel: "Adultos",
    childrenLabel: "Niños",
    adultsPlus: "Agregar un adulto",
    adultsMinus: "Quitar un adulto",
    childrenPlus: "Agregar un niño",
    childrenMinus: "Quitar un niño",
    guestsSummary: "{{adults}} adulto(s), {{children}} niño(s)",
    searchButton: "Buscar",
    allDestinations: "Todos los destinos",
    allCategories: "Todas las categorías",
    goToSlide: "Ir a la diapositiva {{number}}",
    alt1: "Balandra, La Paz, Baja California Sur",
    alt2: "Playa Balandra desde el aire",
    alt3: "Bahía de La Paz",
  },
  categories: {
    title: "Categorías populares",
    adventure: "Aventura",
    cultural: "Cultural",
    gastronomic: "Gastronómico",
    transport: "Transporte",
    housing: "Renta de Casas",
    fishing: "Pesca",
    tourCount: "tours",
  },
  featured: {
    title: "Tours destacados",
    viewDetails: "Ver detalles",
    from: "Desde",
    perPerson: "por persona",
    bestRated: "Mejor valorado",
    saveTour: "Guardar tour",
    reviews: "reseñas",
    scrollLeft: "Desplazar a la izquierda",
    scrollRight: "Desplazar a la derecha",
  },
  destinations: {
    title: "Explora por destino",
    laPaz: "La Paz",
    losCabos: "Los Cabos",
    caboSanLucas: "Cabo San Lucas",
    toursCount: "tours disponibles",
    laPazDesc: "La capital natural de Baja California Sur",
    losCabosDesc: "Donde el desierto encuentra el mar",
    caboSanLucasDesc: "El corazón vibrante de Baja",
  },
  howItWorks: {
    title: "Cómo funciona",
    step1: "Busca",
    step1Desc: "Explora cientos de experiencias únicas en Baja California Sur",
    step2: "Reserva",
    step2Desc: "Elige fecha, hora y número de personas en minutos",
    step3: "Disfruta",
    step3Desc: "Vive momentos inolvidables con los mejores proveedores locales",
  },
  testimonials: {
    title: "Lo que dicen nuestros viajeros",
    previous: "Testimonio anterior",
    next: "Siguiente testimonio",
    goToSlide: "Ir al testimonio {{number}}",
  },
  providerCTA: {
    title: "¿Eres proveedor de servicios turísticos?",
    subtitle: "Únete a BajApp Xperiences y llega a miles de viajeros que buscan experiencias auténticas",
    button: "Registrarme como proveedor",
  },
  footer: {
    about: "Sobre nosotros",
    help: "Ayuda",
    contact: "Contacto",
    social: "Síguenos",
    payments: "Métodos de pago",
    legal: "Legal",
    rights: "Todos los derechos reservados",
    desc: "Conectamos viajeros con experiencias auténticas en Baja California Sur. Tours, transporte y hospedaje con los mejores proveedores locales.",
    whoWeAre: "Quiénes somos",
    team: "Nuestro equipo",
    blog: "Blog",
    press: "Prensa",
    helpCenter: "Centro de ayuda",
    faq: "Preguntas frecuentes",
    cancellationPolicy: "Política de cancelación",
    terms: "Términos y condiciones",
    privacy: "Aviso de privacidad",
  },
  cookieBanner: {
    text: "Utilizamos cookies para mejorar tu experiencia. Al continuar navegando, aceptas nuestra política de cookies.",
    accept: "Aceptar",
    privacy: "Política de privacidad",
  },
  header: {
    toggleMenu: "Abrir o cerrar menú",
    language: "Idioma",
  },
  whatsapp: {
    ariaLabel: "Contactar por WhatsApp",
  },
  notFound: {
    title: "Esta página no ha sido generada",
    desc: "Cuéntame más sobre esta página para poder generarla",
  },
};